import React, { useEffect, useRef } from "react";
import { Circle, Transformer } from "react-konva";

export default function EditableCircle({ circ, selected, onSelect, onChange }) {
  const ref = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (selected && trRef.current && ref.current) {
      trRef.current.nodes([ref.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  if (!circ) return null;

  return (
    <>
      <Circle
        ref={ref}
        x={circ.cx}
        y={circ.cy}
        radius={circ.d / 2}
        fill="rgba(255,255,255,0.06)"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth={1}
        draggable
        onClick={onSelect}
        onTap={onSelect}
        onDragEnd={(e) =>
          onChange({ ...circ, cx: e.target.x(), cy: e.target.y() })
        }
        onTransformEnd={() => {
          const node = ref.current;
          const scale = node.scaleX();
          node.scaleX(1);
          node.scaleY(1);

          onChange({ ...circ, d: Math.max(10, node.radius() * 2 * scale) });
        }}
      />

      {selected && (
        <Transformer
          ref={trRef}
          rotateEnabled={false}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ]}
          borderStroke="#6EE7B7"
          anchorStroke="#6EE7B7"
        />
      )}
    </>
  );
}
